import React from 'react';
import Select from 'react-select';
import cn from 'classnames';

import './ReduxFormSelect.css';

const ReduxFormSelect = props => {
  const { input, options, label, wrapperClassName, meta, required } = props;
  const { error, touched } = meta;
  const isError = error && touched;

  return (
    <div className={cn(wrapperClassName, 'ReduxFormSelectWrapper')}>
      <label className="ReduxFormSelectLabel">
        {label}
        {required && (<span className="ReduxFormSelectAsterisk">*</span>)}
      </label>
      <Select 
        {...input}
        className="ReduxFormSelect"
        classNamePrefix="ReduxFormSelect"
        onChange={option => input.onChange(option.value)} 
        onBlur={() => input.onBlur()} 
        onFocus={() => input.onFocus()} 
        options={options}
        value={options.find(option => option.value === input.value)}
      />
      {isError && (<span className="ReduxFormSelectError"> { error } </span>) }
    </div>
  )
}

export default ReduxFormSelect;